import React, { Component } from "react";
import "moment-timezone";

import {  Modal } from 'react-bootstrap'
import SaleMadeForm from './SaleMadeForm'

class SaleMadeModal extends Component {
  render() {
    const { deal, saleType, showModal, onConfirmModal, onCloseModal } = this.props
    const isUpgrade = saleType === 'upgrade'
    const title = isUpgrade ? "Upgrade / Variation" : "Sale"

    return (
      <Modal show={showModal} onHide={onCloseModal} bsSize="large">
        <Modal.Header closeButton>
          <Modal.Title>{title} Made</Modal.Title>
        </Modal.Header>
        <Modal.Body>
         <SaleMadeForm deal={deal} saleType={saleType} onCancelSubmit={onCloseModal} onSubmit={onConfirmModal} />
        </Modal.Body>
      </Modal>)
  }
}

export default SaleMadeModal